function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1321.64,97.75q43.65-26.27,101.56-26.28a184.2,184.2,0,0,1,84.32,20.24q39.95,20.24,69.77,57.53l47.23-39.42a272.66,272.66,0,0,0-61.44-56.27Q1529,31,1494.38,21.05a256.92,256.92,0,0,0-71.18-9.94q-48.66,0-90.21,13.49t-72.08,37.64a239.89,239.89,0,0,0-52.2,57.18,248.9,248.9,0,0,0-32.32,73,325.51,325.51,0,0,0-10.63,84q0,49.36,13.3,91.62t37.11,73a238.35,238.35,0,0,0,56.1,52.37,242.33,242.33,0,0,0,70.67,32.32,298.55,298.55,0,0,0,80.26,10.64q64.6,0,114.86-26.27a270.83,270.83,0,0,0,86.46-71.37l-47.23-39.77q-62.51,77.06-154.09,77.05a211.06,211.06,0,0,1-61.8-8.88,175.56,175.56,0,0,1-52.74-26.09,182.61,182.61,0,0,1-40.83-41.19q-17.19-24-26.62-55.57a236.39,236.39,0,0,1-9.43-67.83q0-59.64,23.1-106t66.76-72.61"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 1692.12,
  y: 22.95,
  width: 58.58,
  height: 509.43
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1904.17,35.44a41.27,41.27,0,0,0-20.94-5.52q-17.77,0-29.82,12.09a40.06,40.06,0,0,0-12.08,29.46,39.7,39.7,0,0,0,12.08,29.12q12.08,12.07,29.82,12.07a40.68,40.68,0,0,0,29.65-12.07,39.43,39.43,0,0,0,12.25-29.12,40.34,40.34,0,0,0-5.68-20.94,41.27,41.27,0,0,0-15.28-15.09"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 1853.41,
  y: 178.36,
  width: 58.58,
  height: 354.02
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M2433.11,174.09q-40.14,0-73.68,17.93t-55.24,51h-1.4q-27.69-68.89-111.86-68.89a136.94,136.94,0,0,0-66,16.87q-31.26,16.88-52.91,47.75h-1.07V178.36h-58.58v354h58.58V356.61q0-58.59,29.12-93.57t73.51-35q28.07,0,46.52,11.54t28,36.74q9.63,25.22,9.6,63.92V532.38h58.59V356.61q0-58.25,28.41-93.39t71-35.15q42.63,0,62.68,27t20,85.92V532.38H2557V325q0-77-31.26-114t-92.66-36.93"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M2916.84,409q-9.57,23.61-25.92,39.77a118.3,118.3,0,0,1-38,25.21,116.59,116.59,0,0,1-45.46,9.06q-53.26,0-86.27-35.34t-33-89.65q0-58.24,34.28-94.1t85.76-35.86a110.71,110.71,0,0,1,46.85,10.11,113.84,113.84,0,0,1,37.65,27.53,129.79,129.79,0,0,1,24.67,41.36,143,143,0,0,1,9.07,51,134,134,0,0,1-9.6,51m7.46-178.07h-1.41a145.7,145.7,0,0,0-53.44-42.26q-31.44-14.55-68-14.56-49.32,0-89.11,24t-62,65.87q-22.2,41.9-22.18,93.74,0,39.78,13.49,73.51T2678.41,488a166.32,166.32,0,0,0,55.22,36,179.79,179.79,0,0,0,68.17,13q38.72,0,70.48-16a150.83,150.83,0,0,0,53.44-44.74h1.07v56.12h56.46v-354H2924.3Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M3344.38,409q-9.59,23.61-25.74,39.77A117,117,0,0,1,3281,474a113.62,113.62,0,0,1-44.56,9.06q-53.27,0-86.3-35.34t-33-89.65q0-58.24,34.26-94.1t85.76-35.86a107.56,107.56,0,0,1,46.15,10.11,112.85,112.85,0,0,1,37.12,27.53,131.64,131.64,0,0,1,24.5,41.36,143.19,143.19,0,0,1,9.05,51,134.18,134.18,0,0,1-9.58,51m7.45-178.07h-1.06a147.57,147.57,0,0,0-33.55-31.25,145.48,145.48,0,0,0-41-19.17,163.23,163.23,0,0,0-45.81-6.4,172,172,0,0,0-69.25,14q-32.31,14-55,38.35t-35.87,58.41a200.8,200.8,0,0,0-13.13,72.79q0,39.78,13.49,73.51T3107.37,488a166.23,166.23,0,0,0,55.2,36,179.88,179.88,0,0,0,68.18,13,159.55,159.55,0,0,0,48.47-7.28,142.47,142.47,0,0,0,41.36-20.79,152,152,0,0,0,32.67-32.67h1.08v56.12h56.44V23h-58.94Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M3560,35.44a41.47,41.47,0,0,0-21-5.52q-17.74,0-29.82,12.09a40.12,40.12,0,0,0-12.07,29.46,39.76,39.76,0,0,0,12.07,29.12q12.06,12.07,29.82,12.07a40.71,40.71,0,0,0,29.67-12.07,39.43,39.43,0,0,0,12.25-29.12,40.26,40.26,0,0,0-5.69-20.94A41.64,41.64,0,0,0,3560,35.44"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M3509.18,569.66q0,29.12-12.61,43.33c-8.37,9.47-19.58,14.2-33.54,14.2a69,69,0,0,1-36.57-10.66l-9.6,52.19q27.69,12.09,61.08,12.07,41.88,0,66-29.64t24.16-81.49V178.36h-59Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M3907.74,349.86q0,30.52-8.51,56.1t-22.9,42.09a102.45,102.45,0,0,1-33.39,25.55,92.43,92.43,0,0,1-40.29,9.06q-43.68,0-65-25.74t-21.31-84.69V178.36h-58.93V389.27q0,73.88,35,110.78T3790.22,537a135.77,135.77,0,0,0,65-16.34q30.54-16.33,51.48-46.87h1.06v58.59h59v-354h-59Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M4243.12,352.35q-11.71-5.69-68.54-27.7-16.69-6.4-27-11.19a150.54,150.54,0,0,1-20.4-11.54Q4117,295.17,4112.27,287a35.21,35.21,0,0,1-4.8-18.11q0-18.47,16.5-30t37.83-11.55q51.48,0,94.1,36.93l30.54-46.52q-53.29-43.66-121.81-43.66-50.4,0-83.8,27.15t-33.37,67.65a97.51,97.51,0,0,0,5.86,34.44,89.76,89.76,0,0,0,14.74,26.27q8.86,10.67,23.78,20.07a221.38,221.38,0,0,0,28.58,15.45q13.68,6,33.57,12.78c1.88.71,4.73,1.66,8.51,2.84q11.37,4.26,16.87,6.22t14.38,5.33a134.49,134.49,0,0,1,13.32,5.67q4.45,2.29,10.66,5.87a39.3,39.3,0,0,1,9.05,6.57,92.66,92.66,0,0,1,6,7.1,21.74,21.74,0,0,1,4.26,8.7,44.11,44.11,0,0,1,1.06,9.94q0,20.24-18.1,33.72t-49,13.5q-35.16,0-60.55-10.65t-47.74-31.6l-30.56,44.74Q4089.74,537,4171,537q30.89,0,55.58-8t40.11-22a94.65,94.65,0,0,0,23.46-32.32,97,97,0,0,0,8-39.23q0-22.38-7.1-38.72-11.37-26.25-47.93-44.37"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M4550.39,463.48q-31.61,18.11-59.66,18.11-24.13,0-33.72-15.08t-9.6-48.49V229.48h117.18V178.36H4447.41V90.66h-58.94v87.7h-58.11v51.12h58.11V426.9q0,110.09,92,110.1a189.18,189.18,0,0,0,36.58-3.38q17-3.36,27.35-7.81A237.36,237.36,0,0,0,4566,515Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M796.59,471.67a29.89,29.89,0,1,1-29.9,29.89,29.87,29.87,0,0,1,29.9-29.89m0,118.4a88.4,88.4,0,0,0,83.37-59h182.17v-59H880a88.39,88.39,0,0,0-166.74,0H0v59H713.22a88.42,88.42,0,0,0,83.37,59"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M531.47,295a29.83,29.83,0,1,1-29.9,29.9,29.89,29.89,0,0,1,29.9-29.9m-.4,118a88.39,88.39,0,0,0,83.36-59H944.12V295H614.43a88.4,88.4,0,0,0-166.73,0H193a117.74,117.74,0,0,1,162-42.62C354.44,247,354,241.53,354,236a174.54,174.54,0,0,1,6.43-46.42,176.74,176.74,0,0,1,331.09-27.93l46.69-38.95A236.07,236.07,0,0,0,531.07,0c-110,0-202.2,75.4-228.44,177.42-2.48-.13-5-.4-7.59-.4-77,0-142.4,49.3-166.66,118A176.26,176.26,0,0,0,118,354H447.7a88.41,88.41,0,0,0,83.37,59"
});

var SvgClimadjustLiWhite = function SvgClimadjustLiWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 4566.02 680.79",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClimadjustLiWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Climadjust_LI-WHITE.72d4c779.svg";
export { ForwardRef as ReactComponent };